import {
  FormFieldBlueprint,
  createFormField,
} from '@backstage/plugin-scaffolder-react/alpha';
import {
  MigrationTeamPicker,
  MigrationTeamPickerSchema,
} from './MigrationTeamPicker';

export const MigrationTeamPickerExtension = FormFieldBlueprint.make({
  name: 'MigrationTeamPicker',
  params: {
    field: async () =>
      createFormField({
        name: 'MigrationTeamPicker',
        component: MigrationTeamPicker,
        schema: MigrationTeamPickerSchema,
      }),
  },
});
